import { IFilterGridItem } from '@/interfaces/constructor.interfaces';
import { FiltersItemType } from '@/interfaces/filters.interfaces';

import takeExistingFilterValue from './takeExistingFilterValue';

const getFilterInitialValue = (
  key: string,
  value: any,
  filterGridItem?: IFilterGridItem,
  filters?: FiltersItemType,
) => {
  const filterValues = filters?.data?.[key];

  if (typeof filterValues === 'undefined' || typeof filterGridItem === 'undefined') {
    return;
  }

  const resolvedInitialValues = Array.isArray(value) ? value : [value];

  if (!filterValues || !filterGridItem) {
    return;
  }

  const existingFilterValue = takeExistingFilterValue(
    resolvedInitialValues,
    filterValues,
    filterGridItem,
  );

  return existingFilterValue;
};

export default getFilterInitialValue;
